// Icon-Mapping für Fallback-Emojis
export const iconToEmoji = (iconName) => {
  const emojiMap = {
    'beer.png': '🍺',
    'wine.png': '🍷',
    'whisky.png': '🥃',
    'vodka.png': '🥃',
    'gin.png': '🥃',
    'rum.png': '🥃',
    'tequila.png': '🥃',
    'cocktail.png': '🍸',
    'martini.png': '🍸',
    'mojito.png': '🍸',
    'caipirinha.png': '🍸',
    'margarita.png': '🍸',
    'gin-tonic.png': '🍹',
    'rum-cola.png': '🍹',
    'whisky-cola.png': '🍹',
    'cola.png': '🥤',
    'fanta.png': '🥤',
    'sprite.png': '🥤',
    'lemonade.png': '🥤',
    'coffee.png': '☕',
    'espresso.png': '☕',
    'cappuccino.png': '☕',
    'latte.png': '☕',
    'tea.png': '🍵',
    'green-tea.png': '🍵',
    'black-tea.png': '🍵',
    'milk.png': '🥛',
    'hot-chocolate.png': '🥛',
    'water.png': '💧',
    'mineral-water.png': '💧',
    'tap-water.png': '💧',
    'pils.png': '🍺',
    'weissbier.png': '🍺',
    'dark-beer.png': '🍺',
    'red-wine.png': '🍷',
    'white-wine.png': '🍷',
  };
  
  return emojiMap[iconName] || '🍺';
};
